
export class FactRouter {
	static call(kind, value) {
		$.get("factRouter.do", { kind: kind, value: value });
	}
}